import { gql } from "@apollo/client";

export const CREATE_CLIENT_EMAIL_CONFIG = gql`
  mutation createEmailConfig($input: createEmailConfigInput) {
    createEmailConfig(input: $input) {
      clientEmail
    }
  }
`;
export const UPDATE_EMAIL_CONFIG_SCREENS = gql`
  mutation UpdateEmailConfigScreens($input: updateEmailConfigScreensInput) {
    updateEmailConfigScreens(input: $input)
  }
`;

export const GET_EMAIL_CONFIG_BY_ORG = gql`
  query GetEmailConfigByOrg($orgId: Int) {
    getEmailConfigByOrg(orgId: $orgId) {
      Id
      clientEmail
      screens
      supportNumber
    }
  }
`;

export const GET_EMAIL_CONFIG_SCREENS_BY_ID = gql`
  query GetEmailConfigScreensById($Id: Int) {
    getEmailConfigScreensById(Id: $Id) {
      Id
      screens
      orgId
      clientEmail
      defaultMail
      supportNumber
    }
  }
`;

export const DELETE_EMAIL_CONFIG = gql`
  mutation DeleteEmailConfig($Id: Int!) {
    deleteEmailConfig(Id: $Id)
  }
`;
